import axios from 'axios';
import { put, takeLatest, call } from 'redux-saga/effects';

//types
import * as types from '../ActionTypes/BookedUsersActionTypes';

//api
import { user } from '../../BusinessLogic/Network/API/UserApi';
import { SearchUsersActionCreators } from '../ActionCreators/SearchUsersActionCreators';

export class BookedUsersSaga {
    static *getUsers({ meta: { workoutId } }) {
        try {
            const _user = user.create();

            const {
                data: { data },
            } = yield call(axios, _user.bookedUsersRequest(workoutId));
            const response = [...data];

            if (response.length > 0) yield put(SearchUsersActionCreators.getUsersSuccess(response));
            else yield put(SearchUsersActionCreators.getUsersEmpty());
        } catch (e) {
            yield put(SearchUsersActionCreators.getUsersError(e));
        }
    }
}

export function* saga() {
    yield takeLatest(types.GET_BOOKED_USERS, BookedUsersSaga.getUsers);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/BookedUsersSaga.js